import React from "react";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import { Overview } from "./Overview";

export const TripFeatures = () => {
    return(
        <>
             <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-overview-sec-wrapper">
                        <UiCol lg="12">
                            <UiContentCol>
                                <Overview
                                    title="Overview:"
                                    subtitle="Trip Features"
                                />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
        </>
    )
}